/* unplugin-vue-components disabled */import { render } from "./sub-item.vue?vue&type=template&id=7f80341e&scoped=true"
import script from "./sub-item.vue?vue&type=script&lang=js"
export * from "./sub-item.vue?vue&type=script&lang=js"

import "./sub-item.vue?vue&type=style&index=0&id=7f80341e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f80341e"]])

export default __exports__